import axios from "axios";
import { GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";
import { getFirebaseAuth } from "@/firebase/utils";

const state = {
  authUser: JSON.parse(localStorage.getItem("authUser")) || null,
};

const getters = {
  getAuthUser(state) {
    return state.authUser?.user;
  },
  adminRole(state) {
    const roles = ["super-admin", "operation-team", "viewer"];
    const userRoles = state.authUser?.user?.roles || [];
    return roles.some((role) => userRoles.map((r) => r.name).includes(role));
  },
  hrTeamRole(state) {
    const userRoles = state.authUser?.user?.roles || [];
    return userRoles.map((r) => r.name).includes("hr-team");
  },
  isAuthUser(state) {
    // return state.authUser && Date.now() <= state.authUser.expires_at;
    return state.authUser;
  },
  getAuthToken(state, getters) {
    return (
      getters.isAuthUser &&
      `${state.authUser.token_type} ${state.authUser.access_token}`
    );
  },
};

const mutations = {
  setAuthUser(state, payload) {
    state.authUser = payload;
  },
};

const actions = {
  // Dashboard login is Google only: the account's email must belong to an admin, the backend checks that.
  async loginWithGoogle({ commit }) {
    const provider = new GoogleAuthProvider();
    provider.setCustomParameters({ prompt: "select_account" });

    const firebaseAuth = getFirebaseAuth();
    const result = await signInWithPopup(firebaseAuth, provider);
    const googleAccessToken = result._tokenResponse?.oauthAccessToken;
    if (!googleAccessToken) {
      throw new Error("Google did not return an access token");
    }

    try {
      const res = await axios.post("/auth/loginByGoogle", {
        google_access_token: googleAccessToken,
      });
      const response = res.data.data;
      response.expires_at = Date.now() + response.expires_in;
      commit("setAuthUser", response);
      localStorage.setItem("authUser", JSON.stringify(response));
      return "done";
    } catch (error) {
      // Not an admin (401) or any other failure: drop the Google session so another account can be picked
      await signOut(firebaseAuth).catch(() => {});
      throw error;
    }
  },
  logOut({ commit }) {
    return new Promise((resolve) => {
      axios.post("/auth/logout").then(() => {
        commit("setAuthUser", null);
        localStorage.removeItem("authUser");
        signOut(getFirebaseAuth()).catch(() => {});
        resolve("done");
      });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
